import { render, staticRenderFns } from "./app-reg.vue?vue&type=template&id=11cf1d60"
import script from "./app-reg.vue?vue&type=script&lang=js"
export * from "./app-reg.vue?vue&type=script&lang=js"
import style0 from "./app-reg.vue?vue&type=style&index=0&id=11cf1d60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports